module.exports = __webpack_public_path__ + "components/rewards/support/static/logo-6b1652c8b1d23dbc6159a36f8c0d421a.webp";